import { render, staticRenderFns } from "./ShoppingSubmited.vue?vue&type=template&id=3e2f911a"
import script from "./ShoppingSubmited.vue?vue&type=script&lang=js"
export * from "./ShoppingSubmited.vue?vue&type=script&lang=js"
import style0 from "./ShoppingSubmited.vue?vue&type=style&index=0&id=3e2f911a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports